import { MarketStore } from '@/types/stores';
import { cn } from '@/utils/tailwind';
import React, { startTransition } from 'react';

interface MarketTabItemProps {
  uniqueKey: string;
  tabRefs: React.MutableRefObject<Record<string, HTMLButtonElement | null>>;
  setHoveredKey: (key: string | null) => void;
  setSelectedMarket: (market: MarketStore) => void;
  market: MarketStore;
  isActive: boolean | null;
  isHovered?: boolean;
  hasOrder: boolean;
}

const MarketTabItem = ({
  uniqueKey,
  tabRefs,
  setHoveredKey,
  setSelectedMarket,
  market,
  isActive,
  isHovered = false,
  hasOrder,
}: MarketTabItemProps) => {
  return (
    <button
      key={uniqueKey}
      ref={(el) => (tabRefs.current[uniqueKey] = el)}
      onMouseEnter={() => setHoveredKey(uniqueKey)}
      onMouseLeave={() => setHoveredKey(null)}
      onClick={() => {
        startTransition(() => setSelectedMarket(market));
      }}
      className={cn(
        'relative z-10 flex flex-shrink-0 items-center gap-1.5 overflow-hidden rounded-[8px] px-[8px] py-[6px] font-medium transition-colors duration-300',
        isActive ? 'bg-white text-gr-700' : 'text-gr-500 hover:text-gr-700',
      )}
    >
      {market.marketIconUrl && market.marketId !== 0 && (
        <img
          src={market.marketIconUrl}
          alt=""
          className={cn(
            'z-20 h-[20px] w-[20px] opacity-100 transition-opacity duration-300 ',
            !isActive && !isHovered && 'opacity-50',
          )}
        />
      )}
      <span className="z-20 flex items-center Body5M14">
        {market.marketAlias || market.storeId || market.marketId}
      </span>
      {hasOrder && (
        <span
          className=" right-2 top-1.5 h-1  w-1  self-start rounded-full bg-statusRed-400"
          // style={{ boxShadow: '0 0 0 2px ' }}
        />
      )}
    </button>
  );
};

export default MarketTabItem;
